import React, {useEffect, useCallback} from "react";

import {
    Typography, IconButton, InputBase, Tooltip, Chip,
  } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";

import * as actions from "../../store/actions";


const SiteSelector = (props) => {
  const dispatch = useDispatch();

  const allSites = useSelector(state => state.sites.allSites);

  const sitesToShow = props.allowedSites
    ? allSites.rows.filter(site => props.allowedSites.some(s => s._id === site._id))
    : allSites.rows;

  const isSiteSelected = (siteToCompare) => {
    const index = props.selectedSites.findIndex(site => {
        return site._id === siteToCompare._id
    })
    return index > -1
  }

  return (
    <div style={styles.titleContainer}>
			{sitesToShow.map((site, index) =>
				<Chip key={site._id} style={styles.chip} onClick={() => props.selectSite(site)} label={site.name} variant={isSiteSelected(site) ? 'default' : 'outlined'} />
      )}
    </div>
  );
};

export default SiteSelector;

const styles = {
	titleContainer: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
	},
	chip: {
		cursor: 'pointer',
		marginRight: 5,
		marginBottom: 5,
	},
};
